module.exports = __webpack_public_path__ + "img/preview-7.2d649d2a.webp";